import type { TourEvent } from '@/features/events';
import { Grid, Section } from '@/components/layout';
import { IconFeature } from '@/components/ui';
import { Reveal } from '@/components/motion';
import styles from './PilaresMexico.module.css';

export interface PilaresMexicoProps {
  event: TourEvent;
}

/**
 * S3 · TRES PILARES — banda y 870-1027 del mockup.
 *
 * Los tres bloques salen de `event.benefits` (icono, título y cuerpo tipados):
 * ni el rótulo ni el icono se teclean aquí.
 *
 * El `Reveal` envuelve la rejilla ENTERA y no cada celda: `RevealGroup` mete un
 * envoltorio por hijo y entonces cada `IconFeature` pasa a ser `:last-child` de
 * su propia caja, con lo que los filetes verticales de `divided` desaparecen.
 */
export function PilaresMexico({ event }: PilaresMexicoProps) {
  return (
    <Section background="surface" spacing="tight" className={styles.section}>
      <Reveal>
        <Grid variant="thirds" gap="fluid" className={styles.grid}>
          {event.benefits.map((benefit) => (
            <IconFeature key={benefit.id} benefit={benefit} layout="column" divided />
          ))}
        </Grid>
      </Reveal>
    </Section>
  );
}
